import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import FormBox from './FormBox';

const OTP_LENGTH = 6;
const EXPIRY_SECONDS = 10 * 60;
const RESEND_COOLDOWN = 60;

export default function OtpForm({ onVerify, onResend }) {
  const [digits, setDigits] = useState(Array(OTP_LENGTH).fill(""));
  const [secondsLeft, setSecondsLeft] = useState(EXPIRY_SECONDS);
  const [resendCooldown, setResendCooldown] = useState(RESEND_COOLDOWN);
  const inputs = useRef([]);

  useEffect(() => {
    setSecondsLeft(EXPIRY_SECONDS);
    const timer = setInterval(() => {
      setSecondsLeft(s => (s > 0 ? s - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (resendCooldown <= 0) return;
    const timer = setInterval(() => {
      setResendCooldown(s => (s > 0 ? s - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, [resendCooldown > 0]);

  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  const countdown = `${minutes}:${String(seconds).padStart(2, '0')}`;

  function handleChange(index, e) {
    const val = e.target.value.replace(/\D/g, "").slice(-1);
    const next = [...digits];
    next[index] = val;
    setDigits(next);
    if (val && index < OTP_LENGTH - 1) {
      inputs.current[index + 1].focus();
      inputs.current[index + 1].select();
    }
  }

  function handleKeyDown(index, e) {
    if (e.key === "Backspace" && !digits[index] && index > 0) {
      inputs.current[index - 1].focus();
      inputs.current[index - 1].select();
    }
  }

  function handlePaste(e) {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, OTP_LENGTH);
    const next = [...digits];
    for (let i = 0; i < pasted.length; i++) next[i] = pasted[i];
    setDigits(next);
    const focusIndex = Math.min(pasted.length, OTP_LENGTH - 1);
    inputs.current[focusIndex].focus();
  }

  function submit() {
    const code = digits.join("");
    if (code.length === OTP_LENGTH) onVerify(code);
  }

  function resend() {
    onResend();
    setSecondsLeft(EXPIRY_SECONDS);
    setResendCooldown(RESEND_COOLDOWN);
  }

  return (
    <FormBox title="Enter Verification Code">
      <p className="otp-hint">
        A verification code has been sent to your email.
        <Button bsStyle="link" className="tw-ms-5 tw-text-[#337ab7]" onClick={resend} disabled={resendCooldown > 0}>{resendCooldown > 0 ? `RESEND CODE in ${resendCooldown}s` : 'RESEND CODE'}</Button>
      </p>
      <p>
        {secondsLeft > 0 ? <>The code expires in <strong>{countdown}</strong>.</> : <span style={{ color: 'red' }}>The code has expired. Please request a new one.</span>}
      </p>
      <div className="otp-form">
        <div className="otp-inputs" onPaste={handlePaste}>
          {digits.map((d, i) => (
            <input
              key={i}
              ref={el => (inputs.current[i] = el)}
              type="text"
              inputMode="numeric"
              autoComplete={i === 0 ? 'one-time-code' : 'off'}
              maxLength={1}
              value={d}
              onChange={e => handleChange(i, e)}
              onKeyDown={e => handleKeyDown(i, e)}
              className="otp-box"
            />
          ))}
        </div>
      </div>
      
      <div className="clearfix btnCon">
        <Button
          className="btn btn-primary pull-right flip btn-submit btn-effect"
          onClick={submit}
          disabled={digits.join("").length < OTP_LENGTH}
        >
          <span>Verify</span>
          <i className="picon picon-btn-arrow-right-w" />
        </Button>
      </div>
    </FormBox>
  );
}
